import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import SupportRequestConfirmationDto = Cloud.RavenDB.Core.Dto.Support.SupportRequestConfirmationDto;
import SupportRequestDto = Cloud.RavenDB.Core.Dto.Support.SupportRequestDto;
import SupportContractRequestDto = Cloud.RavenDB.Core.Dto.Support.SupportContractRequestDto;
import SupportContextDto = Cloud.RavenDB.Core.Dto.Support.SupportContextDto;

export default class SupportService extends AbstractService {
    sendSupportMessage = async (dto: SupportRequestDto): Promise<SupportRequestConfirmationDto> => {
        const response = await this.post<SupportRequestDto, SupportRequestConfirmationDto>(
            ApiRoutes.support.supportRequest(),
            dto
        );
        return response.data;
    };

    supportContractRequest = async (dto: SupportContractRequestDto): Promise<void> => {
        await this.post<SupportContractRequestDto, void>(ApiRoutes.support.supportContractRequest(), dto);
    };

    loadContext = async (domainName: string): Promise<SupportContextDto> => {
        const response = await this.query<SupportContextDto>(ApiRoutes.support.loadContext({ domainName }));
        return response.data;
    };
}
